import { reactive } from "vue";

export const loaderState = reactive({ visible: false, message: "" });

const MAX_VISIBLE_MS = 60000; // safety net: never leave the screen blocked
let sequence = 0;
const pending = new Map();

function refresh() {
  const shown = [...pending.values()].filter((entry) => entry.shown);
  loaderState.visible = shown.length > 0;
  loaderState.message = shown.length ? shown[shown.length - 1].message : "";
}

export function startLoader({ delay = 500, message = "" } = {}) {
  const id = ++sequence;
  const entry = { message, shown: false, timer: null, guard: null };
  entry.timer = setTimeout(() => {
    entry.shown = true;
    refresh();
  }, delay);
  entry.guard = setTimeout(() => stopLoader(id), MAX_VISIBLE_MS);
  pending.set(id, entry);
  return id;
}

export function stopLoader(id) {
  const entry = id ? pending.get(id) : null;
  if (!entry) return;
  clearTimeout(entry.timer);
  clearTimeout(entry.guard);
  pending.delete(id);
  refresh();
}